import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "1440",
  height: "32",
  viewBox: "0 0 1440 32",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M-2.79753e-06 31.9999L-1.82263e-06 20.8483C85.8119 20.8483 238.241 -0.044807 492 -8.28768e-05C801.476 0.0544612 1199.4 31.3182 1440 31.3182L1440 32L720 31.9999L-2.79753e-06 31.9999Z",
      fill: "#AD0014"
    }, null, -1)
  ])))
}
export default { render: render }